import { isProd } from '@/utils'
import {
  ccipConfig as ccipConfigProd,
  ccipConfigtestnet,
  CCIPHelper,
  LSTHelper,
  LSTVaultHelper,
  config as prodConfig,
  vaultConfig as prodVaultConfig,
  testconfig,
  testvaultConfig,
} from '@/utils/sdk'

import { rpcs } from '@/utils/sdk/src/config/rpcs'
import { priceService } from '@/utils/sdk/src/priceHelper'

import { useAppKitProvider } from '@reown/appkit/vue'

import { BrowserProvider, Contract, JsonRpcProvider } from 'ethers'
import { formatUnits, parseUnits } from 'viem'

export async function getProvider() {
  const { walletProvider } = useAppKitProvider('eip155')
  const ethersProvider = new BrowserProvider(walletProvider as any)

  return ethersProvider
}

async function sendTransactionEthers(calldataInfo: any) {
  const ethersProvider = await getProvider()
  const signer = await ethersProvider.getSigner()
  console.log('signer', signer.address)
  const txHash = await signer.sendTransaction({
    to: calldataInfo.target,
    value: calldataInfo.value,
    data: calldataInfo.data,
  })
  console.log('txHash', txHash)
  await txHash.wait(2)
  // const txReceipt = ethersProvider.getTransactionReceipt(txHash.)
  return txHash
}

// 定义统一的返回类型接口

export const config = isProd ? prodConfig : testconfig
export const vaultConfig = isProd ? prodVaultConfig : testvaultConfig
export const ccipConfig = isProd ? ccipConfigProd : ccipConfigtestnet

export function isL2ChainId(chainId?: number | string) {
  if (!chainId) {
    return false
  }
  return [1946, 1868].includes(Number(chainId))
}
interface UserInfo {
  balances: {
    ASTR?: string
    WASTR?: string
    WstASTR?: string
    formASTR: string
  }

  vaultTotalAssets?: string
  vaultTotalStake?: string
}

// 定义统一的合约接口
interface IContractAdapter {
  isCcip: boolean
  getUserInfo: (address: string) => Promise<UserInfo>
  getBridgeData?: (address: string) => Promise<any>
  approveMax: () => Promise<any>
  convertToShares: (amount: string) => Promise<any>
  convertToAssets: (amount: string) => Promise<any>
  stake: (account: string, amount: bigint) => Promise<any>
  unstake: (account: string, amount: string) => Promise<any>
  getUnstakeNonceList: (account: string) => Promise<any>
  checkBridgeAmount: (account: string, amount: string) => Promise<any>
  bridgeSend: (account: string, amount: string) => Promise<any>
  getPrice?: (token: string) => Promise<any>
  instantUnstake: (account: string, amount: string) => Promise<any>
  getStakedAmountOnContract: () => Promise<any>

  // ... 其他通用方法
}

export async function waitTx(txHash: `0x${string}`) {
  await new Promise<void>((resolve, _reject) => {
    setTimeout(resolve, 1000)
  })
  const ethersProvider = await getProvider()
  const txReceipt = ethersProvider.getTransactionReceipt(txHash)
  return txReceipt
}
export async function sendTx(calldataInfo: any) {
  // const hash = await sendTransaction(wagmiAdapter.wagmiConfig, {
  //   to: calldataInfo.target,
  //   value: calldataInfo.value,
  //   data: calldataInfo.data,
  // })
  const tx = await sendTransactionEthers(calldataInfo)
  // console.log(hash)

  // 等待交易确认
  // const receipt = await waitTx(hash as any)

  return { transactionHash: tx.hash }
}

// Shibuya 链适配器
export class MinatoAdapter implements IContractAdapter {
  helper: LSTHelper
  isCcip = true
  static readonly EXPLORE_URL = 'https://ccip.chain.link/address/'

  constructor() {
    this.helper = new LSTHelper(config, { L1: false, L2: false })
  }

  async getUserInfo(address: string): Promise<UserInfo> {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const result = await helper.getUserStatus(address)
    const balances = result.L2.balances
    console.log(result, 'result')
    return {
      balances: {
        WASTR: formatUnits(balances?.WASTR, 18),
        WstASTR: formatUnits(balances?.WstASTR, 18),
        formASTR: formatUnits(balances?.WASTR, 18),
      },
    }
  }

  async convertToShares(amount: string) {
    return this.helper.convertToShares(amount)
  }

  async convertToAssets(amount: string) {
    return this.helper.convertToAssets(amount)
  }

  async approveMax() {
    return await this.helper.approveMaxToRouter()
  }

  async stake(account: string, amount: bigint) {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const message = await helper.createVaultDepositMessage({
      amount,
      address: account as string,
      useNative: true,
    })
    const checkResult = await helper.ccipTransferCheck(message, account)
    console.log(checkResult, 'checkResult')
    if (!checkResult.success) {
      // 如果检查失败，则检查是否是因为手续费不足
      const fees = checkResult.data?.fees || 0
      const feeTokenBalance = checkResult.data?.feeTokenBalance || 0
      if (Number(fees) > Number(feeTokenBalance)) {
        throw new Error('Insufficient Fee')
      }

      throw new Error(checkResult.errors[0])
    }
    try {
      const calldataInfo = await helper.getccipTransferCalldata(message)
      // const result = await this.helper.sendTransaction(calldataInfo)
      const result = await sendTx(calldataInfo.calldata)

      return result
    }
    catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
  }

  async unstake(account: string, amount: string) {
    const message = await this.helper.createVaultUnstakeMessage({
      amount,
      address: account as string,
      useNative: true,
    })
    const checkResult = await this.helper.ccipTransferCheck(message, account)
    console.log(checkResult, 'checkResult')
    if (!checkResult.success) {
      throw new Error(checkResult.errors[0])
    }
    try {
      const calldataInfo = await this.helper.getccipTransferCalldata(message)
      // const result = await this.helper.sendTransaction(calldataInfo)
      const result = await sendTx(calldataInfo.calldata)

      return result
    }
    catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
  }

  async instantUnstake(account: string, amount: string) {
    console.log(amount, 'amount')
    const message = await this.helper.createVaultInstantUnstakeMessage({
      amount,
      address: account as string,
      useNative: true,
    })
    const checkResult = await this.helper.ccipTransferCheck(message, account)
    console.log(checkResult, 'checkResult')
    if (!checkResult.success) {
      throw new Error(checkResult.errors[0])
    }
    try {
      const calldataInfo = await this.helper.getccipTransferCalldata(message)
      // const result = await this.helper.sendTransaction(calldataInfo)
      const result = await sendTx(calldataInfo.calldata)

      return result
    }
    catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
  }

  async getUnstakeNonceList(account: string) {
    const result = await this.helper.getUserUnstakeFromNonce(account, 0)
    return result.filter((item: any) => item.pendingUnstakeChain.toString() === '2')
  }

  async checkBridgeAmount(account: string, amount: string) {
    const bridgeMessage = await this.helper.createBridgewstASTRMessage({
      fromChain: 'L2',
      toChain: 'L1',
      amount, //
      receiverAddress: account, // 接收地址
      useNative: true, // 使用原生代币支付费用
    })

    const checkResult = await this.helper.ccipTransferCheck(bridgeMessage, account)
    return { checkResult, bridgeMessage }
  }

  async bridgeSend(account: string, amount: string) {
    const { checkResult, bridgeMessage } = await this.checkBridgeAmount(account, amount)
    console.log(checkResult, 'checkResult')
    if (!checkResult.success) {
      throw new Error(checkResult.errors[0])
    }
    try {
      const calldataInfo = await this.helper.getccipTransferCalldata(bridgeMessage)
      // const result = await this.helper.sendTransaction(calldataInfo)
      const result = await sendTx(calldataInfo.calldata)
      return result
    }
    catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
  }

  async getStakedAmountOnContract() {
    // L2 链不需要这个方法，返回 0 或抛出错误
    // 如果需要在 L2 上也实现，可以使用类似 ShibuyaAdapter 的逻辑
    throw new Error('getStakedAmountOnContract is not supported on L2 chain')
  }
}

// Astar 链适配器
export class ShibuyaAdapter implements IContractAdapter {
  helper: LSTVaultHelper
  helper2: LSTHelper
  isCcip = false
  static readonly EXPLORE_URL = isProd
    ? 'https://astar.subscan.io/tx/'
    : 'https://shibuya.blockscout.com/tx/'

  constructor() {
    this.helper = new LSTVaultHelper(vaultConfig, false)
    this.helper2 = new LSTHelper(config, { L1: false, L2: false })
  }

  async getUserInfo(address: string): Promise<UserInfo> {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const result = await helper.getUserL1Status(address)
    const balances = result.balances
    console.log(result, 'getUserInfo')
    return {
      balances: {
        ASTR: formatUnits(BigInt(balances.ASTR), 18),
        WASTR: formatUnits(BigInt(balances.ASTR), 18),
        WstASTR: formatUnits(balances.WstASTR, 18),
        formASTR: formatUnits(BigInt(balances.ASTR), 18),
        // ... 转换其他字段
      },
    }
  }

  async getStakedAmountOnContract() {
    const dappStakingAddress = '0x45cCC0DEA1470F1b4213Ab60fd2eBB2a063f1c24'
    const stakerAddress = '0x75B05f40a0005ff13Ae1588F5e295D87622FB557'
    const result = await this.helper2.readStakedAmountOnContract(dappStakingAddress, stakerAddress)
    return formatUnits(result, 18)
  }

  async convertToShares(amount: string) {
    const helper = new LSTVaultHelper(vaultConfig, false)
    return helper.convertToShares(amount)
  }

  async convertToAssets(amount: string) {
    const helper = new LSTVaultHelper(vaultConfig, false)
    return helper.convertToAssets(amount)
  }

  async approveMax() {
    try {
      const result = await this.helper.approveMaxToVault()
      if (result) {
        return {
          success: true,
          data: result,
          errors: [],
        }
      }
    }
    catch (error) {
      return {
        success: false,
        data: null,
        errors: [error instanceof Error ? error.message : String(error)],
      }
    }
  }

  async stake(account: string, amount: bigint) {
    const calldataInfo = await this.helper.getDepositASTRCallData(account, amount)
    const result = await sendTx(calldataInfo)
    return result
    // return this.helper.depositASTR(account, amount) // 假设 Astar 用 deposit 代替 stake
  }

  async unstake(account: string, amount: string) {
    const calldataInfo = await this.helper.getRequestUnstakeCallData(amount)
    const result = await sendTx(calldataInfo)
    return result
    // return this.helper.requestUnstake(amount) // 假设 Astar 用 withdraw 代替 unstake
  }

  async instantUnstake(account: string, amount: string) {
    const calldataInfo = await this.helper.getInstantWithdrawCallData(amount)
    const result = await sendTx(calldataInfo)
    return result
    // return this.helper.instantWithdraw(amount)
  }

  async getUnstakeNonceList(account: string) {
    const result = await this.helper.getUserUnstakeFromNonce(account, 0)
    return result.filter((item: any) => item.pendingUnstakeChain.toString() === '0')
  }

  async checkBridgeAmount(account: string, amount: string) {
    const bridgeMessage = await this.helper2.createBridgewstASTRMessage({
      fromChain: 'L1',
      toChain: 'L2',
      amount, //
      receiverAddress: account, // 接收地址
      useNative: true, // 使用原生代币支付费用
    })

    const checkResult = await this.helper2.ccipTransferCheck(bridgeMessage, account)
    return { checkResult, bridgeMessage }
  }

  async bridgeSend(account: string, amount: string) {
    const { checkResult, bridgeMessage } = await this.checkBridgeAmount(account, amount)
    console.log(checkResult, 'checkResult')
    if (!checkResult.success) {
      throw new Error(checkResult.errors[0])
    }
    try {
      const calldataInfo = await this.helper2.getccipTransferCalldata(bridgeMessage)
      // const result = await this.helper2.sendTransaction(calldataInfo)
      const result = await sendTx(calldataInfo.calldata)
      return result
    }
    catch (error) {
      throw new Error(error instanceof Error ? error.message : String(error))
    }
  }
}

// 合约工厂类
export class ContractHelper {
  static instanceMap = new Map<number, ContractHelper>()
  minatoAdapter: IContractAdapter
  shibuyaAdapter: IContractAdapter
  adapter: IContractAdapter
  exploreUrlPrefix: string
  chainId: number

  constructor(chainId: number) {
    this.shibuyaAdapter = new ShibuyaAdapter()
    this.minatoAdapter = new MinatoAdapter()
    this.adapter = isL2ChainId(chainId) ? this.minatoAdapter : this.shibuyaAdapter
    this.exploreUrlPrefix = this.createExploreUrl(chainId)
    this.chainId = chainId
  }

  static getInstance(chainId: number): ContractHelper {
    let instance = this.instanceMap.get(chainId)
    if (!instance) {
      instance = new ContractHelper(chainId)
      this.instanceMap.set(chainId, instance)
    }
    return instance
  }

  createExploreUrl(chainId: number): string {
    if (isL2ChainId(chainId)) {
      return MinatoAdapter.EXPLORE_URL
    }
    else {
      return ShibuyaAdapter.EXPLORE_URL
    }
  }

  async approveMax() {
    try {
      return this.adapter.approveMax()
    }
    catch (error) {
      console.error('Error approveMax:', error)
      throw error
    }
  }

  async getBridgeData(address: string) {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const result = await helper.getUserStatus?.(address)
    console.log(result, 'getBridgeData')
    return {
      l1: formatUnits(result?.L1.balances.WstASTR, 18),
      l2: formatUnits(result?.L2.balances.WstASTR, 18),
    }
  }

  async getPrice(token: string): Promise<any> {
    const priceList = await priceService.getAllPrices(token)
    const priceItem = priceList.find(item => item.price)
    return priceItem?.price
  }

  /**
   * 获取 Astar链 Vault 的 ASTR 余额
   * @returns Astar链 Vault 的 ASTR 余额
   */
  async getVaultBalance() {
    try {
      const rpc = rpcs.astar
      if (!rpc) {
        throw new Error('RPC address not found')
      }
      const provider = new JsonRpcProvider(rpc)
      const vaultAddress = vaultConfig.contracts.deploy.Vault

      // 通过 RPC 获取 Vault 合约的 ASTR 余额
      const balance = await provider.getBalance(vaultAddress)

      return {
        astrBalance: formatUnits(balance, 18),
        success: true,
      }
    }
    catch (error) {
      console.error('Error getting vault balance:', error)
      return {
        astrBalance: '0',
        success: false,
        error: error instanceof Error ? error.message : String(error),
      }
    }
  }

  // 获取当前Astar链区块高度
  async getBlockNumber() {
    try {
      const rpc = rpcs.astar
      if (!rpc) {
        throw new Error('RPC address not found')
      }
      const provider = new JsonRpcProvider(rpc)

      // 通过 RPC 获取 Vault 合约的 ASTR 余额
      const blockNumber = await provider.getBlockNumber()
      const block = await provider.getBlock(blockNumber)

      return {
        blockNumber,
        timestamp: block?.timestamp,
        success: true,
      }
    }
    catch (error) {
      console.error('Error getting block number:', error)
      return {
        blockNumber: 0,
        success: false,
        error: error instanceof Error ? error.message : String(error),
      }
    }
  }

  // 获取ASTAR链区块时间戳
  async getBlockTimestamp(blockNumber: number) {
    try {
      const rpc = rpcs.astar
      if (!rpc) {
        throw new Error('RPC address not found')
      }
      const provider = new JsonRpcProvider(rpc)
      const block = await provider.getBlock(blockNumber)
      return {
        timestamp: block?.timestamp,
        success: true,
      }
    }
    catch (error) {
      return {
        timestamp: 0,
        success: false,
        error: error instanceof Error ? error.message : String(error),
      }
    }
  }

  // 获取当前Astar链区块高度和时间戳
  async getAstarBlockInfo() {
    const rpc = rpcs.astar
    if (!rpc) {
      throw new Error('RPC address not found')
    }
    // 动态引入 EthersUtils，避免循环依赖
    const { EthersUtils } = await import('@/utils/sdk/utils/ethersUtils')
    const ethersUtils = new EthersUtils(rpc)
    // 获取区块高度
    const blockNumber = await ethersUtils.getLatestBlockNumber()
    // 获取区块时间戳
    const timestamp = await ethersUtils.getBlockTimestamp(blockNumber)
    return { blockNumber, timestamp }
  }

  // 统一的公共接口
  async getUserInfo(address: string): Promise<UserInfo> {
    try {
      const result = await this.adapter.getUserInfo(address)
      return result
    }
    catch (error) {
      console.error('Error getting user info:', error)
      throw error
    }
  }

  async getTotalStake() {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const result = await helper.getVaultStatus()
    const total = result.vaultTotalAssets ? formatUnits(BigInt(result.vaultTotalAssets), 18) : '0'
    console.log(total, result, 'total')
    return total
  }

  async checkAllowance(tokenAddress: string, account: string, toAddress?: string) {
    try {
      const chain = isL2ChainId(this.chainId) ? 'L2' : 'L1'
      const routerAddress = toAddress || config[chain]?.ccip.Router

      if (!routerAddress) {
        throw new Error('Router address not found')
      }

      const ethersProvider = await getProvider()
      const contract = new Contract(tokenAddress, config.abis.IERC20, ethersProvider)
      const allowance = await contract.allowance(account, routerAddress)
      const allowanceString = formatUnits(allowance, 18)
      console.log(allowance, typeof allowance, allowanceString, 'allowance')
      return allowanceString
    }
    catch (error) {
      console.error('Error checking allowance:', error)
      throw error
    }
  }

  async approveToken(tokenAddress: string, amount: string, toAddress?: string) {
    try {
      const amountInWei = parseUnits(amount, 18)
      const chain = isL2ChainId(this.chainId) ? 'L2' : 'L1'
      const routerAddress = toAddress || config[chain]?.ccip.Router

      if (!routerAddress) {
        throw new Error('Router address not found')
      }

      const ethersProvider = await getProvider()
      const signer = await ethersProvider.getSigner()
      const contract = new Contract(tokenAddress, config.abis.IERC20, signer)
      console.log('signer', signer.address)
      const tx = await contract.approve(routerAddress, amountInWei)
      // const transactionReceipt = await waitTx(tx.hash)
      await tx.wait(1)
      console.log(tx, 'transactionReceipt')

      return { transactionHash: tx.hash }
    }
    catch (error) {
      console.error('Error ApproveToken:', error)
      throw error
    }
  }

  async convertToShares(amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      const returnAmount = await this.adapter.convertToShares(amountWei)
      return formatUnits(BigInt(returnAmount), 18)
    }
    catch (error) {
      console.error('Error convertToShares:', error)
      throw error
    }
  }

  async convertToAssets(amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      const returnAmount = await this.adapter.convertToAssets(amountWei)
      return formatUnits(BigInt(returnAmount), 18)
    }
    catch (error) {
      console.error('Error convertToAssets:', error)
      throw error
    }
  }

  async stake(account: string, amount: string) {
    try {
      const amountWei = parseUnits(amount, 18)

      return await this.adapter.stake(account, amountWei)
    }
    catch (error) {
      console.error('Error staking:', error)
      throw error
    }
  }

  async unstake(account: string, amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      return await this.adapter.unstake(account, amountWei)
    }
    catch (error) {
      console.error('Error unstaking:', error)
      throw error
    }
  }

  async getInstantUnstakeLimit() {
    const helper = new LSTHelper(config, { L1: false, L2: false })
    const limit = await helper.getInstantUnstakeLimit()
    const limitString = formatUnits(BigInt(limit), 18)
    return limitString
  }

  async instantUnstake(account: string, amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      return await this.adapter.instantUnstake(account, amountWei)
    }
    catch (error) {
      console.error('Error unstaking:', error)
      throw error
    }
  }

  async getUnstakeNonceList(account: string) {
    try {
      const list = await this.adapter.getUnstakeNonceList(account)
      console.log(list, 'list')
      const returnList = list.map((item: any) => {
        return {
          nonce: item.nonce,
          pendingUnstakeChain: item.pendingUnstakeChain.toString(),
          pendingUnstakeAt: item.pendingUnstakeAt.toString(),
          pendingUnstake: formatUnits(item.pendingUnstake, 18),
        }
      })
      return returnList
    }
    catch (error) {
      console.error('getUnstakeNonceList:', error)
      throw error
    }
  }

  async checkBridgeAmount(account: string, amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      return await this.adapter.checkBridgeAmount(account, amountWei)
    }
    catch (error) {
      console.error('Error bridgeSend:', error)
      throw error
    }
  }

  async bridgeSend(account: string, amount: string) {
    try {
      const amountWei = parseUnits(amount, 18).toString()
      return await this.adapter.bridgeSend(account, amountWei)
    }
    catch (error) {
      console.error('Error bridgeSend:', error)
      throw error
    }
  }

  async getMessageId(txHash: string) {
    try {
      const ccipHelper = new CCIPHelper(ccipConfig)
      const chain = isL2ChainId(this.chainId) ? 'L2' : 'L1'
      await waitTx(txHash as `0x${string}`)
      const result = await ccipHelper.getMessageID(txHash, chain)

      return result.messageId
    }
    catch (error) {
      console.error('Error getMessageId:', error)
    }
  }

  // !!!startTimestamp 为开始时间戳，如果超过1小时，直接返回 { state: 'SUCCESS' }
  async getCCIPStatus(messageId: string, startTimestamp?: number) {
    try {
      if (startTimestamp && (Date.now() / 1000 - startTimestamp > 3600)) {
        return { state: 'SUCCESS' }
      }
      const ccipHelper = new CCIPHelper(ccipConfig)
      const result = await ccipHelper.getTransferStatus(messageId, 'L2', 20000)
      return result
    }
    catch (error) {
      console.error('Error getTransferStatus:', error)
      throw error
    }
  }

  async getTxStatus(txHash: string, address: string, type: string) {
    try {
      const ccipHelper = new CCIPHelper(ccipConfig)
      const chain = isL2ChainId(this.chainId) ? 'L2' : 'L1'
      const status: any = {}
      if (type === 'stake') {
        const result = await ccipHelper.getDepositStatus(txHash, address, 10000)
        console.log(result, 'getTxStatus')
        if ((result.step === 2 && result.state === 'SUCCESS') || result.state === 'OUT_OF_RANGE') {
          status.isSuccess = true
        }
      }
      else if (type === 'unstake' || type === 'instantUnstake') {
        const result = await ccipHelper.getUnstakeStatus(txHash, 64800, 10000)
        console.log(result, 'getTxStatus')
        if (result.state === 'UNLOCKED') {
          status.isSuccess = true
        }
      }
      else if (type === 'bridge') {
        const result = await ccipHelper.getBridgeStatus(txHash, chain)
        console.log(result, 'getTxStatus')
        if (result.state === 'SUCCESS') {
          status.isSuccess = true
        }
      }

      console.log(status, 'status')
      return status
    }
    catch (error) {
      console.error('Error getMessageId:', error)
      throw error
    }
  }
}

// 使用示例
export function useContract(chainId: number) {
  return ContractHelper.getInstance(chainId)
}
